export default __webpack_public_path__ + "static/importanceThumb-caa7a193df3c0f341ddde6ede53c9f20.jpg";